import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  motionDisabled: false,
  setMotionDisabled: () => {},
};

const UserStoreContext = createContext(defaultState);

const UserStore = ({ children }) => {
  const [isMotionDisabled, setIsMotionDisabled] = useState(false);

  const setMotionDisabled = isDisabled => {
    setIsMotionDisabled(isDisabled);
    // Set local storage
    localStorage.setItem('is-motion-disabled', JSON.stringify(isDisabled));

    // Since all animation is killed we have to refresh the page:
    if (!isDisabled) {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (isMotionDisabled) {
      document.body.classList.add('is-motion-disabled');
    } else {
      document.body.classList.remove('is-motion-disabled');
    }
  }, [isMotionDisabled]);

  useEffect(() => {
    // Check if motion has been disabled before
    const lsMotionDisabled = JSON.parse(
      localStorage.getItem('is-motion-disabled')
    );
    // Only set it should be disabled
    if (lsMotionDisabled && !isMotionDisabled) {
      setMotionDisabled(true);
    }
  }, []);

  return (
    <UserStoreContext.Provider
      value={{
        motionDisabled: isMotionDisabled,
        setMotionDisabled,
      }}
    >
      {children}
    </UserStoreContext.Provider>
  );
};

UserStore.propTypes = {
  children: PropTypes.node,
};

export { UserStore, UserStoreContext };
